
import { useMemo } from "react";
import LogoWallSlider from "../LogoWallSlider";

export default function Partenaires({ partenaire = [] }) {
  const items = useMemo(() => {
    if (!Array.isArray(partenaire)) return [];
    return partenaire.filter((p) => Number(p.type) === 1);
  }, [partenaire]);

  const COLORS = {
    primary: "#123465",
    secondary: "#f9a836",
    lightBg: "#f5faff",
    white: "#fff",
  };

  return (
    <LogoWallSlider
      items={items}
      title="Nos partenaires"
      highlight="& technologies"
      subtitle="Nous collaborons avec des leaders reconnus pour garantir fiabilité, sécurité et évolutivité."
      bg={COLORS.lightBg}
    />
  );
}
